const code = {
    china: '+86',
    hongKong: '+852',
    macau: '+853',
    taiwan: '+886',
    singapore: '+65',
    malaysia: '+60',
    indonesia: '+62',
    thailand: '+66',
    philippines: '+63',
    vietnam: '+84',
    myanmar: '+95'
}

export default code



// WEBPACK FOOTER //
// ./src/components/business/country-code/code.js